import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.network.firewall.ruleset.create;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_FIREWALL_RULESET_CREATE',
	method: 'POST',
	url: '/network/firewall/ruleset/create.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
